<i18n>
[
    "browse__shoppableImage--cta",
]
</i18n>

<template>
    <div class="c-shoppable-image-module">
        <div @click="launchShoppingModal">
            <ImageModule
                :backgroundImage="backgroundImage"
                :buttons="buttons"
                :editorialText="editorialText"
                :isFullWidth="true"
                :numberOfModules="1"
            >
                <div
                    v-tab-focus="launchShoppingModal"
                    :class="{
                        'c-shoppable-image-module__button-outer': true,
                        'c-shoppable-image-module__button-outer--left': ctaPosition === 'left',
                        'c-shoppable-image-module__button-outer--right': ctaPosition === 'right',
                    }"
                >
                    <div class="c-shoppable-image-module__button-container">
                        <BaseIcon
                            icon="global--eye"
                            size="16px"
                            color="black"
                            class="c-shoppable-image-module__icon"
                        />
                        <p class="c-shoppable-image-module__icon-text u-text--black o-text--caption">
                            {{ $t('browse__shoppableImage--cta') }}
                        </p>
                    </div>
                </div>
            </ImageModule>
        </div>
    </div>
</template>

<script>
import { isEmpty } from 'lodash-es';
import { mapActions } from 'vuex';

import { MAX_SHOPPABLE_IMAGE_DRAWER_PRODUCTS } from '~coreModules/contentful/js/contentful-constants';
import { MODALS } from '~modules/modals/js/modal-constants';

import { MODALS_MODULE_NAME, LAUNCH_MODAL } from '~coreModules/modals/js/modals-store';

import ImageModule from '~coreModules/contentful/components/ImageModule.vue';

export default {
    name: 'ShoppableImageModule',
    components: {
        ImageModule,
    },
    props: {
        id: {
            type: String,
            default: null,
        },
        backgroundImage: {
            type: Object,
            default: () => ({
                smallImage: {},
            }),
        },
        buttons: {
            type: Object,
            default: null,
        },
        editorialText: {
            type: Object,
            default: null,
        },
        choiceIds: {
            type: Array,
            required: true,
        },
        ctaPosition: {
            type: String,
            default: 'left',
            validator: position => ['left', 'right'].includes(position),
        },
    },
    data() {
        const trimmedChoiceIds = this.choiceIds ?
            [...this.choiceIds].splice(0, MAX_SHOPPABLE_IMAGE_DRAWER_PRODUCTS) : [];

        return {
            modalOptions: {
                ...MODALS.shopTheLook,
                props: {
                    id: this.id,
                    choiceIds: trimmedChoiceIds,
                },
            },
        };
    },
    created() {
        if (isEmpty(this.choiceIds)) {
            this.$logger.debugError(`ShoppableImageModule was authored without any choiceIds,
                republish with choiceIds added`);
        }
    },
    methods: {
        ...mapActions(MODALS_MODULE_NAME, {
            launchModal: LAUNCH_MODAL,
        }),
        launchShoppingModal() {
            this.launchModal(this.modalOptions);
        },
    },
};
</script>

<style lang="scss">
    .c-shoppable-image-module {
        $this: &;
        cursor: pointer;

        &__button-outer {
            padding: $nu-spacer-1;
            position: absolute;
            bottom: $nu-spacer-1;

            @include breakpoint(medium) {
                bottom: $nu-spacer-2;
            }

            &--left {
                left: $nu-spacer-1;

                @include breakpoint(medium) {
                    left: $nu-spacer-2;
                }
            }

            &--right {
                right: $nu-spacer-1;

                @include breakpoint(medium) {
                    right: $nu-spacer-2;
                }
            }

            &:hover,
            &:focus[data-focus-visible-added] {
                #{$this}__icon-text {
                   max-width: 15rem;
                   padding-right: $nu-spacer-0pt5;
                   margin-left: $nu-spacer-1;
                }
            }
        }

        &__button-container {
            padding: $nu-spacer-1;
            border-radius: 8px;
            background-color: rgba(255, 255, 255, 0.75);
            cursor: pointer;
            display: inline-flex;
            align-items: center;
        }

        &__icon {
            height: 10px;
            display: inline-flex;
            align-items: center;
        }

        &__icon-text {
            max-width: 0;
            display: inline-block;
            line-height: 1.4rem;
            transition: .15s ease-in-out;
            white-space: nowrap;
            overflow: hidden;
        }
    }
</style>
